import { useSettings } from "@/context/SettingsContext";
import { trackClick } from "@/lib/api";
import { Bot, MessageCircle } from "lucide-react";

const STEPS = [
  { n: "01", title: "Scegli il bookmaker", text: "Consulta le promozioni disponibili e scegli il partner più adatto alle tue esigenze." },
  { n: "02", title: "Usa il link Vinko", text: "Clicca sul pulsante di registrazione presente sul sito." },
  { n: "03", title: "Completa la registrazione", text: "Inserisci i dati richiesti dal bookmaker e completa la verifica del conto." },
  { n: "04", title: "Ricevi assistenza", text: "Contatta Vinko attraverso Telegram o WhatsApp in caso di necessità." },
];

export default function ComeFunziona() {
  const s = useSettings();
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 sm:py-20">
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-500">Guida</span>
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter">
        Inizia in <span className="text-yellow-400">pochi passaggi</span>
      </h1>

      <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((st) => (
          <div key={st.n} className="rounded-2xl border border-white/10 bg-[#101010] p-6">
            <div className="text-yellow-400 text-5xl font-black tracking-tighter mb-3">{st.n}</div>
            <h3 className="text-lg font-semibold">{st.title}</h3>
            <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{st.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 flex flex-col sm:flex-row gap-3">
        <a
          href={s.whatsapp_url}
          target="_blank" rel="noopener"
          onClick={() => trackClick("whatsapp")}
          data-testid="cf-whatsapp"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-yellow-400 hover:bg-yellow-300 text-black font-bold text-sm px-6 py-3 transition-transform duration-200 hover:scale-[1.02]"
        >
          <MessageCircle className="w-4 h-4" /> RICHIEDI ASSISTENZA SU WHATSAPP
        </a>
        <a
          href={s.telegram_bot_url}
          target="_blank" rel="noopener"
          onClick={() => trackClick("telegram_bot")}
          data-testid="cf-bot"
          className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 hover:border-yellow-400 hover:text-yellow-400 text-white font-bold text-sm px-6 py-3 transition-colors duration-200"
        >
          <Bot className="w-4 h-4" /> APRI IL BOT TELEGRAM
        </a>
      </div>
    </div>
  );
}
